module.exports = __webpack_public_path__ + "static/media/Raleway-Regular.f4b782bd.ttf";